import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import { useParams, useNavigate } from 'react-router-dom';
import { DarkMembersPandaView } from '@/components/playlist/preview/DarkMembersPandaView';
// TODO: Implement API call to fetch dark members settings
// import { mockDarkMembersSettings } from './mockDarkMembersData';

const mockDarkMembersSettings = {
  modules: [],
  settings: {},
};

export default function DarkMembersModulePreview() {
  useLanguage();
  const { moduleId } = useParams<{ moduleId: string }>();
  const navigate = useNavigate();

  const module = mockDarkMembersSettings.modules
    .filter((m: any) => m.isActive)
    .find((m: any) => m.id === moduleId);

  if (!module) {
    return (
      <div className="min-h-screen bg-[#0E0E0E] flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-white text-2xl font-bold mb-2">
            {translateInterfaceText("Módulo não encontrado")}</h1>
          <p className="text-gray-400">
            {translateInterfaceText("Verifique se o link está correto.")}</p>
        </div>
      </div>
    );
  }

  const handleBack = () => {
    navigate('/playlist/preview/dark-members');
  };

  return (
    <DarkMembersPandaView 
      module={module}
      onBack={handleBack}
    />
  );
}
